import { connect } from '../../../react-redux';
import InteractionTypes from './presenter';
import { featureOn } from '../../../../common/util/featureCheck';
function mapStateToProps(state) {
  return {
    allowPassageCreation: featureOn('passage')
  };
}
export default connect(mapStateToProps)(InteractionTypes);